"use strict";

import { historyConstants } from "../_constants";
import { accountConstants } from "../_constants";
import { from, of, iif } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import {
  mergeMap,
  catchError,
  map,
  concatMap,
  startWith,
} from "rxjs/operators";

import { getRequestHeader } from "../../_helpers/request.header";
import { payloadFormatter } from "../../_helpers/encryption.helper";
import { ajaxError, transactionHistoryDetailError } from "../_actions";
import {
  transactionHistoryListComplete,
  transactionHistoryListRequest,
  transactionHistoryDetailComplete,
} from "../_actions";

export const transactionHistoryListEpic = (actions$) =>
  actions$.pipe(
    ofType(historyConstants.TRANSACTION_HISTORY_LIST_REQUEST),
    mergeMap((action) => {
      const { isFiltering, ...payload } = action.payload;

      return ajax
        .post(
          "/api/history/transactionHistoryList",
          payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => {
            return transactionHistoryListComplete({
              list: ajaxResponse.response.data.transactionHistoryList,
              isFiltering,
            });
          }),
          catchError((error) => of(ajaxError(error))),
        );
    }),
  );

export const transactionHistoryDetailsEpic = (actions$) =>
  actions$.pipe(
    ofType(historyConstants.TRANSACTION_HISTORY_DETAIL_REQUEST),
    mergeMap((action) => {
      const { ...payload } = action.payload;

      return ajax
        .post(
          "/api/history/getTransactionDetail",
          payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => {
            return transactionHistoryDetailComplete(
              ajaxResponse.response.data.transactionInfo,
            );
          }),
          catchError((error) =>
            of(transactionHistoryDetailError(error), ajaxError(error)),
          ),
        );
    }),
  );
